module.exports = __webpack_public_path__ + "img/west-indies-logo-icon.2eedf064.png";